module.exports = __webpack_public_path__ + "static/elco-badge-1a-1371eff4c7d06a6c6b92b5eb55c0f0ec.png";